import { motion } from "framer-motion";

/**
 * Branded MyyntiDrive spinner. Uses the logo mark rotating continuously.
 *
 * Sizes:
 *  - `xs`  16px  – inline / tiny inputs
 *  - `sm`  20px  – inside buttons (recommended default)
 *  - `md`  40px  – small section loaders
 *  - `lg`  72px  – full-section loaders (empty states, admin lists)
 *
 * The mark PNG is a non-square (M + upward arrow) — rotating it around center
 * produces a natural sweeping motion that reads as "loading".
 */
const SIZES = {
  xs: { h: "h-4", track: "h-4 w-4" },
  sm: { h: "h-5", track: "h-5 w-5" },
  md: { h: "h-10", track: "h-10 w-10" },
  lg: { h: "h-16", track: "h-16 w-16" },
};

export default function Spinner({ size = "sm", label, className = "", "data-testid": testId = "spinner" }) {
  const s = SIZES[size] || SIZES.sm;
  return (
    <span
      className={`inline-flex items-center gap-3 ${className}`}
      role="status"
      aria-live="polite"
      data-testid={testId}
    >
      <span className={`relative grid place-items-center ${s.track}`} aria-hidden="true">
        <motion.img
          src="/logo-mark.png?v=1"
          alt=""
          className={`${s.h} w-auto object-contain`}
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.6, ease: "linear" }}
          draggable={false}
        />
      </span>
      {label && <span className="text-sm text-white/70">{label}</span>}
      {!label && <span className="sr-only">Ladataan</span>}
    </span>
  );
}
